<template>
    <div class="faq-container">
        <div class="container">
            <div class="inner-page-title">Imprint</div>
            <div class="terms-body">
                <div class="imprint-left">
                    Vindome EOOD
                    <br/>
                    9 Simeonovsko shose Blvd
                    <br/>
                    entr. E, fl. 7, apt. 115
                    <br/>
                    1700, Sofia
                    <br/>
                    Bulgaria
                    <br/><br/>
                    Phone: +33 6 45 45 16 50 *
                    <br/>
                    (Mon. – Fri., 09:00 – 17:00 hours)
                    <br/>
                    E-mail: <a href="mailto:info@vindome.net">info@vindome.net</a>
                    <br/>
                    Internet: <a href="https://vindome.net/">https://vindome.net/</a>
                    <br/><br/>
                    <small>* For all other queries, please use the <nuxt-link :to="localePath('/support')">Contact Us</nuxt-link> section of the website.</small>
                </div>
                <div class="imprint-right">
                    <strong>Registration</strong>
                    <br/>
                    Monaco RCI 19S08128
                    <br/><br/>
                    <strong>VAT registration number</strong>
                    <br/>
                    FR38 000143213
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Imprint",
        head: {
            title: 'Imprint | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-terms trading-desk'
            }
        }
    }
</script>

<style scoped>
    .faq-container {
        background: #ffffff;
        padding-top: 80px;
    }
    .container {
        max-width: 1170px;
        padding: 0;
        margin: 0 auto;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    }
    .inner-page-title {
        font-size: 49px;
        line-height: 49px;
        text-align: center;
        color: #303030;
        margin-top: 47px;
        margin-bottom: 53px;
    }
    .terms-body {
        padding: 40px 0;
        font-size: 16px;
        font-weight: 400;
    }
    .imprint-left, .imprint-right {
        display: inline-block;
        width: 50%;
        vertical-align: top;
    }
</style>
<style>
    .barcode-page .logo {
        padding-right: 0;
    }
    .v-navigation-drawer--is-mobile {
        z-index: 106;
    }
</style>
